import MuiChip, { type ChipProps } from '@mui/material/Chip';

export type { ChipProps };

const Chip = (props: ChipProps) => <MuiChip {...props} />;

export default Chip;
